import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { WinkelService } from '../_services/winkel.service';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

interface CategoryOrder {
  id: number;
  name: string;
  order: number;
}

@Component({
  selector: 'app-shop-detail',
  templateUrl: './shop-detail.component.html',
  styleUrls: ['./shop-detail.component.css'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, DragDropModule, MatIconModule, MatButtonModule],
})
export class ShopDetailComponent implements OnInit {
  id: number;
  shopname: string = '';
  categories: CategoryOrder[] = [];
  saved = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private winkelService: WinkelService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.id = +params['shopId'];
      this.loadShop();
      this.loadCategories();
    });
  }

  private loadShop(): void {
    this.winkelService.getWinkel(this.id).subscribe({
      next: (data) => {
        const shop = JSON.parse(data);
        this.shopname = shop.name ?? '';
        this.cdr.detectChanges();
      },
      error: () => {},
    });
  }

  private loadCategories(): void {
    this.winkelService.getShopCategories(this.id).subscribe({
      next: (data) => {
        this.categories = JSON.parse(data);
        this.saved = false;
        this.cdr.detectChanges();
      },
      error: () => {},
    });
  }

  drop(event: CdkDragDrop<CategoryOrder[]>): void {
    moveItemInArray(this.categories, event.previousIndex, event.currentIndex);
    this.saved = false;
  }

  saveOrder(): void {
    const ordered = this.categories.map((cat, index) => ({ id: cat.id, order: index }));
    this.winkelService.saveShopCategoryOrder(this.id, ordered).subscribe({
      next: () => {
        this.saved = true;
        this.cdr.detectChanges();
      },
      error: () => {},
    });
  }

  deleteShop(): void {
    this.winkelService.deleteWinkel(this.id).subscribe({
      next: () => this.router.navigate(['/profile']),
      error: () => {},
    });
  }
}
